import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Chip,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faArrowLeft, faArrowRightFromBracket, faChevronLeft, faChevronRight, faFileCircleCheck, faSquareXmark } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from "react-redux"
import { setTokenExpiry } from "../state/authSlice"
import { isMobile } from "react-device-detect"

export default function MainContainer({
  children,
  info = [],
  pageName = "",
  breadcrumbs = [],
  prevPage = {},
}) {
  const [expiryTime, setExpiryTime] = useState(null);

  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch();

  useEffect(() => {

    if (token && token != "") {

      const decoded = jwtDecode(token);

      // Extract the expiration time and convert it to a human-readable format
      const expirationTime = new Date(decoded.exp * 1000); // Convert from seconds to milliseconds

      let hours = expirationTime.getHours();
      const minutes = expirationTime.getMinutes();
      const seconds = expirationTime.getSeconds();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert 24-hour format to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 becomes 12 (for midnight)

      // Format minutes and seconds to always show two digits
      const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} `;

      setExpiryTime(formattedTime + " " + ampm); // Show in a readable format

      dispatch(setTokenExpiry(expirationTime.getTime() / 1000))
    }
  }, []);

  return (
    //mt-10 ismobil
    <div radius="none" className={`${isMobile ? "mt-10" : ""} " border-0 rounded-none min-h-screen lg:ml-60 lg:pr-5 z-1"`}>
      {/* lg:ml-64 */}
      <ToastContainer className='toast-container'
        toastClassName="dark-toast"
        progressClassName="progress-toast"
      // closeButton={<FontAwesomeIcon  className=" text-xl text-orange-600 absolute right-4 top-1/2 -translate-y-1/2" icon={faSquareXmark} />}
      />
      <div className="flex p-1 w-full flex-col gap-1 
      bg-gradient-to-br from-white to-lfime-50 border-0 
       items-start sticky align-top">
        <div className="flex items-center justify-between w-full ">

          <div className="flex items-center justify-start ">

            {/* breadcrumbs */}
            {breadcrumbs?.length > 0 && (
              <Breadcrumbs color="warning" variant="light" className="text-sm">

                {breadcrumbs?.map((item) => {
                  return (
                    <BreadcrumbItem className="text-xs text-white" key={item}>
                      {item}
                    </BreadcrumbItem>
                  )
                })}
              </Breadcrumbs>
            )}
            {/* end of breadcrumbs */}

          </div>
          <div className=" text-xs font-semibold bg-h-100 text-rose-400">
            {"session expire at :" + expiryTime}
          </div>
        </div>
        <div className="w-full">
          {/* page heading */}
          <div className="flex items-center justify-end w-full mb-2 border-b-2  border-slate-500">
            <div color="primary" radius="sm" className="w-full text-slate-700 py-1
             uppercase ml-0" ><div className=" text-xs text-orange-500 font-semibold flex items-center gap-2" >
                <div className=" bg-gradient-to-b from-white to-orange-100 border-1 py-1 px-2">
                  <FontAwesomeIcon className="text-slate-700     font-semibold text-md " icon={faArrowRightFromBracket} ></FontAwesomeIcon>
                </div>
                {pageName} </div> </div>

            {prevPage && prevPage?.show && (
              <Chip
                size="md"
                color="success"
                variant="flat"
                className=" p-2 cursor-pointer bg-gradient-to-t from-lime-800 to-lime-400 text-white"
                radius="sm"
                startContent={<FontAwesomeIcon icon={faArrowLeft} />}
                onClick={prevPage?.onClick}
              >
                BACK
              </Chip>
            )}
          </div>
          <div className=" flex  flex-wrap text-gray-500 text-xs font-semibold">
            {info.map((infoItem, index) => {
              return (
                <div>
                  <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                  <Chip key={index} variant="light"
                    color="primary" className="text-xs">
                    {infoItem.map((item, index) =>
                      //return (

                      item + " "

                      // )

                    )}
                  </Chip>
                </div>
              )
            })}
          </div>
          {/* end of page heading */}
        </div>
      </div>
      <div className="">{children}</div>
      <div></div>
    </div>
  )
}
